export default __webpack_public_path__ + "static/lara-4bd9eebb4fcc5714a9ed54637946d373.webp";